export default "__VITE_ASSET__C_UOWk3K__"